import React from "react";

const EventApps = () => {
  return <div>Event Apps</div>;
};

export default EventApps;
